import type { DealProposalResponse } from '@makemydeal/dr-sales-checkin-types';
import {
    DEAL_PROPOSAL_FETCH_REQUEST,
    DEAL_PROPOSAL_FETCH_SUCCESS,
    DEAL_PROPOSAL_FETCH_FAILURE,
    GET_DEAL_PROPOSAL
} from './actionTypes';

export const getDealProposal = () => ({
    type: GET_DEAL_PROPOSAL
});

export const fetchDealProposalRequest = () => ({
    type: DEAL_PROPOSAL_FETCH_REQUEST
});

export const fetchDealProposalSuccess = (payload: DealProposalResponse) => ({
    type: DEAL_PROPOSAL_FETCH_SUCCESS,
    payload
});

export const fetchDealProposalFailure = (errorMessage: string) => ({
    type: DEAL_PROPOSAL_FETCH_FAILURE,
    payload: errorMessage
});
